// extracted by mini-css-extract-plugin
export default {"volume-changer":"Volume_volume-changer__dkIzJ"};